<template>
  <el-card body-style="padding: 0">
    <div slot="header" class="card_header">
      <span>打卡回報統計 {{ department ? `部門：${department}` : '' }} </span>
      <span style="color:red; font-size: 18px;">(統計資訊於凌晨00：00統計前日資料)</span>
    </div>
    <div class="button_container">
      <div class="filter-wrapper">
        <div>回報日期：</div>
        <el-date-picker class="w-150px" v-model="startDate" @change="getStatisticData" placeholder="開始日期"/>
        <span class="w-30px text-center">到</span>
        <el-date-picker class="w-150px" v-model="endDate" @change="getStatisticData" placeholder="结束日期"/>
        <el-button type="primary" icon="el-icon-refresh-right"
                   class="ml-10px" @click="getStatisticData">
          重查
        </el-button>
      </div>
    </div>
    <stat-table
        ref="statTable"
        title="打卡回報統計"
        :row-style="{cursor:'pointer'}"
        day-order="descending"
        :columns="statColumns"
        @row-click="openDetails"
        :fetch-length="fetchLengthFn"
        :fetch-excel-data="fetchExcelData"
        :fetch-method="getPagedData"
        :default-sort="{prop:'report_date',order:'descending'}">
      <el-table-column prop="report_date" sortable label="回報日期" />
      <el-table-column prop="sum_uncheck" label="未打卡">
        <template slot-scope="scope">
          <el-button type="text" class="unreport"
                     @click.stop="openEmpDialog(scope.row.day)">
            {{ new Intl.NumberFormat().format(scope.row.sum_uncheck) }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="sum_check_in" label="已打卡" />
      <el-table-column prop="total_num" :formatter="numberFormatter" label="合計"/>
    </stat-table>
  </el-card>
</template>

<script>
import {ref} from "@vue/composition-api";
import DateUtil from "@/utils/dateUtil";
import StatTable from "@/components/StatTable";
import CheckinLogService from "@/api/checkinLog";
import MessageService from "@/components/Message";
import LoadingService from "@/components/Loading";
import {openEmployeeDialog} from '../dialog/useEmployeeDialog';
import {getDetailData} from './CheckinDetail';
import {department} from "@/views/useDepartment";

export default {
  name: "Statistic",
  components: {
    'stat-table': StatTable
  },
  setup() {

    const statTable = ref(null);
    const startDate = ref(null);
    const endDate = ref(new Date());
    const loading = ref(true);

    const statColumns = ref([
      {label: "回報日期", prop: "report_date"},
      {label: "未打卡", prop: "sum_uncheck"},
      {label: "已打卡", prop: "sum_check_in"},
      {label: "合計", prop: "total_num"},
    ]);

    const transformerFn = (array = []) => {

      return array.map(single => {

        const getReportDate = date => `${DateUtil.format(date, "YYYY/MM/DD")}(${DateUtil.getWeekDayStr(date)})`;
        const new_date = DateUtil.toDate(single.day, "YYYY-MM-DD");

        return {
          report_date: getReportDate(single.day),
          day: single.day,
          date: new_date,

          // 如果當天沒有人回報 , new_date = null , 會造成 getTime 呼叫錯誤
          timestamp: new_date && new_date.getTime(),
          sum_check_in: single.sum_check_in,
          total_num: single.employee_num,
          sum_uncheck: single.sum_uncheck
        };
      });
    }

    const fetchLengthFn = async () => {

      const {totalLength} = await CheckinLogService.getTotalLength({
        start: startDate.value,
        end: endDate.value,
        depts: department.value
      })

      return totalLength;
    }

    const getPagedData = async ({order, limit, offset}) => {

      const pagedData = await CheckinLogService.statWithLimit({
        order,
        limit,
        offset,
        department: department.value,
        startDate: startDate.value,
        endDate: endDate.value,
      })
      console.log(pagedData)

      return transformerFn(pagedData);
    }

    const fetchExcelData = async ({order}) => {

      LoadingService.open('下載 EXCEL 中...');
      let excelData = [];

      try {

        const params = {
          department: department.value,
          order,
          limit: 10000 * 10000 * 10000,
          offset: 0,
          startDate: startDate.value,
          endDate: endDate.value,
        }

        excelData = await CheckinLogService.statWithLimit(params);
        console.log('下載 EXCEL 中...');
        console.log(excelData);

      } catch (e) {

        console.error(e);
        MessageService.error(`錯誤提示：${e.title} , ${e.message}`);
      }

      LoadingService.close();
      return transformerFn(excelData);
    }

    // 取得某天某部門的明細資料
    const openDetails = ({date}) => {

      getDetailData({date, department: department.value})
          .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
    }

    const openEmpDialog = date => {

      // open the global loading mask
      LoadingService.open('取得未回報員工資料中...');
      // date . department
      CheckinLogService.getUnReports({date, department: department.value})
          .then(employees => {

            LoadingService.close(300, () => openEmployeeDialog('未回報員工列表', employees));
          })
          .catch(e => {

            LoadingService.close(300, () => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
          });
    }

    const numberFormatter = (row, column /* , cellValue, index */) => {
      const number = row[column.property];
      return new Intl.NumberFormat().format(number);
    }

    const getStatisticData = () => statTable.value.fetchData();

    return {
      department,
      statColumns,
      statTable,
      loading,
      startDate,
      endDate,
      openEmpDialog,
      transformerFn,
      fetchExcelData,
      fetchLengthFn,
      getPagedData,
      numberFormatter,
      openDetails,
      getStatisticData,
    }
  },
}
</script>

<style scoped>

.filter-wrapper {
  display: flex;
  align-items: center;
}

.unreport:hover {
  transform: scale(1.3);
}

</style>
